import styles from './NewsList.module.scss';
import { Spinner } from 'ui/components/1-atoms/Media/Spinner/Spinner';
import { PreviewCardProps } from 'ui/components/2-molecules/Card/PreviewCard/PreviewCard';
import { PreviewCardList } from 'ui/components/3-organisms/PreviewCardList/PreviewCardList';
import ColorOptions, { LinkType } from 'helpers/types';
import classNames from 'classnames';
import { Container } from 'ui/components/4-habitats/Container/Container';

export interface NewsListProps {
	rootFolderId?: number;
	count?: number;
	offset?: number;
	buttonText?: string;
	bgColor?: ColorOptions;
	filter?: string;
	link?: LinkType;
	newsFetcher: (
		rootId: number,
		limit: number,
		offset: number,
		filter?: string,
	) => {
		articles?: PreviewCardProps[];
		isLoading: boolean;
	};
}

export const NewsList: React.FC<NewsListProps> = ({ rootFolderId, count, offset, buttonText, bgColor, filter, newsFetcher }) => {
	const rootId = rootFolderId ? rootFolderId : 0;
	const limitQuery = count === 0 ? null : count;
	const offsetQuery = offset >= 0 ? offset : null;
	const newsResult = newsFetcher(rootId, limitQuery, offsetQuery, filter);

	if (newsResult.isLoading) return <Spinner style="large" />;
	if (!newsResult.articles) return <></>;

	return (
		<div className={classNames(styles.NewsList_cards, styles[`u-color___${bgColor}`])}>
			<Container width="Standard">
				<PreviewCardList items={newsResult.articles} desktopWidth="100" mobileWidth="100" buttonText={buttonText} />
			</Container>
		</div>
	);
};
